<template>
  <div class="h-full" ref="sunburstChartContainer" >
    <div v-show="dataAvailable" >
      <div :key="update" class="h-fit mt-4 w-fit mx-auto flex flex-col space-y-16" ref="sunburstChart"></div>
    </div>
    <div v-show="!dataAvailable" class="h-full  flex justify-center">
      <p class="self-center -mt-6 text-center">{{ $t('widget.noData') }}</p>
    </div>
  </div>
</template>



<script setup>
import Sunburst from 'sunburst-chart';
import {defineEmits, defineProps, onMounted, ref, watch} from "vue";
import * as d3 from 'd3'
import ApiService from "@/services/ApiService";
let apiService = new ApiService();
const emit = defineEmits(["dataLoaded", 'dataUnloaded'])

let props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})
let sunburstChart = ref(null);
let dataAvailable = ref(true);
let sunburstChartContainer = ref(null);
let chart = ref();
let width = ref(500);
let subject = ref("");
onMounted( async () => {
  if (screen.width < 625){
    width.value = 310;
  }
  chart.value = Sunburst()
  await refreshData()
  emit("dataLoaded")
    }
)
watch(() => props.update, async () => {
  emit("dataUnloaded")
  if (sunburstChart.value.childNodes.length >=1 ){
    sunburstChart.value.removeChild(sunburstChart.value.childNodes[0]);
  }
  await refreshData();
  if (sunburstChart.value.childNodes.length >=2 ){
    sunburstChart.value.removeChild(sunburstChart.value.childNodes[0]);
    emit("dataLoaded")
  }else{
    emit("dataLoaded")
  }
})

async function refreshData() {

  let apiData = await apiService.get(props.source);
  if(! apiData.data.children.length > 0){

    dataAvailable.value = false;
  }
  else {
    subject.value = " " + await apiData.subject

    dataAvailable.value = true;
    let color = d3.scaleOrdinal(props.colorPalette.pieChart);
    chart.value
        .data(apiData.data)
        .size('size')
        .sort((a, b) => b.value - a.value)
        .height(500)
        .color(d => color(d.name))
        .width(width.value)
        .minSliceAngle(1)
        .maxLevels(3)
        .radiusScaleExponent(1)
        // .excludeRoot(true)
        .tooltipTitle((d) => `<div class="font-normal" style="text-align: left"> ${makeTooltip(d)}</div>`)
        .tooltipContent((d, node) => `<i class="font-bold">${node.value}${subject.value}</i>`)
        // eslint-disable-next-line no-unexpected-multiline
        (sunburstChart.value)
  }
}

function makeTooltip(node){
  let res = [];
  let hasParents = true;
  let beginNode = node.__dataNode
  while (hasParents)
  {
    if (beginNode.parent == null){
      hasParents = false;
    }else{
      res.push(beginNode.data.name);
      beginNode = beginNode.parent
    }
  }
  res.reverse()
  let label = ``
  let first = true;
  let divider = '>';
  res.forEach(entry => {
    if (first){
      label += `<p>> ${entry}</p>`
      first = false;
    }else{
      divider +='>';
      label += `<p>${divider} ${entry}</p>`
    }
  })
  return label
}
</script>


<style>
.sunburst-viz .tooltip
{
  max-width: 4000px !important;
}


.tooltipcomponent {
  position: relative;
  display: inline-block;
}

.tooltipcomponent .tooltiptext {
  visibility: hidden;
  width: 200px;
  background-color: gray;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  z-index: 1;

  /* Fade in tooltip - takes 1 second to go from 0% to 100% opac: */
  opacity: 0;
  transition: opacity 0.5s;
}


/*.tooltipWideWidget .tooltiptextWideWidget {*/
/*  left: 30%;*/
/*  top: -3rem;*/
/*}*/

.tooltipcomponent:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
</style>
